exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".OrgUnitDialog-content {\n    height: 300px;\n    max-height: 300px;\n}\n\n.OrgUnitDialog-metadata {\n    font-size: 14px;\n    margin-top: -10px;\n    width: 200px;\n    float: left;\n}\n\n.OrgUnitDialog-metadata h3 {\n    margin: 10px 0 2px 0;\n    font-size: 14px;\n}\n\n.OrgUnitDialog-data {\n    float: left;\n    width: 345px;\n}\n\n.OrgUnitDialog-nodata {\n    font-style: italic;\n    padding: 5px;\n    font-size: 14px;\n}\n\n.OrgUnitDialog-table {\n    display: block;\n    font-size: 14px;\n    width: 345px;\n    max-height: 240px;\n    overflow-y: auto;\n}\n\n.OrgUnitDialog-table .left {\n    text-align: left;\n    width: 280px;\n}\n\n.OrgUnitDialog-table .right {\n    text-align: right;\n    vertical-align: top;\n    width: 65px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./src/components/orgunits/OrgUnitDialog.css
// module id = 1226
// module chunks = 0